import type { Variant } from '../utils';

import IconFloatingMembership from '~/assets/icons/card_banner/icon_floating_membership.svg';
import IconFloatingSolid from '~/assets/icons/card_banner/icon_floating_solid.svg';
import IconFloatingStroke from '~/assets/icons/card_banner/icon_floating_stroke.svg';

interface PrefixLogo {
  variant: Variant;
}

const iconMap = {
  solid: IconFloatingSolid,
  stroke: IconFloatingStroke,
  membership: IconFloatingMembership,
};

const PrefixLogo = ({ variant }: PrefixLogo) => {
  const IconComponent = iconMap[variant] || IconFloatingSolid;

  return <IconComponent />;
};
export default PrefixLogo;
